import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { Input } from '@components/core-ui/form-elements/Input';
import { useAPI } from '@providers/useAPI';
import { JobsService } from 'app/API';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { ModalTitle } from '@modals/core-ui/ModalTitle';
import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { Content } from './styles/Content';
import { TProps } from './types/TProps';

export const AddNewAttorneysAccessModal = ({ wsid, id, recordingSessionId, onCancel, onSuccess }: TProps) => {
  const { call } = useAPI();
  const [email, setEmail] = useState('');

  const createNewAttorneysAccess = async () => {
    if (!recordingSessionId) {
      onSuccess({ email, createdAt: new Date().toISOString() });
      onCancel();
      return;
    }
    call(
      JobsService.addNewAttorneyAccess({
        wsid,
        jobId: id,
        email,
        recordingSessionId,
      }),
      {
        onError: (message) => toast.error(message),
        onSuccess: (data) => {
          toast.success('Access created!');
          onSuccess(data);
          onCancel();
        },
      },
    );
  };

  return (
    <ModalWrapper width="400px">
      <ModalTitle>Add new attorneys access</ModalTitle>

      <Content>
        <Input
          label="Attorneys Email"
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => setEmail(event.target.value)}
          value={email}
        />

        <div className="buttonWrapper w-full max-w-[70%] self-end">
          <OutlinedButton onClick={() => onCancel()}>Cancel</OutlinedButton>
          <Button onClick={createNewAttorneysAccess} disabled={!email}>
            Create
          </Button>
        </div>
      </Content>
    </ModalWrapper>
  );
};
